import { render, staticRenderFns } from "./Functionality.vue?vue&type=template&id=56163cd2&"
import script from "./Functionality.vue?vue&type=script&lang=js&"
export * from "./Functionality.vue?vue&type=script&lang=js&"
import style0 from "./Functionality.vue?vue&type=style&index=0&id=56163cd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports